import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";

export const makePaymentVoid = ({ churchId, requisitionId, voidData }) => {
  return axios.post(
    `/churches/${churchId}/requisitions/${requisitionId}/void?_method=PATCH`,
    voidData
  );
};

export const useMakePaymentVoid = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(["requisitions"]);
      queryClient.invalidateQueries(["requisitions-paginated"]);
      queryClient.invalidateQueries(["requisition"]);

      setNotification({
        type: "success",
        message: "Payment voided successfully!"
      });

      navigate("/finances/temp/expense/requisition");
    },
    ...config,
    mutationFn: makePaymentVoid
  });
};
